var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bootscreensignin-div" },
    [
      _c("div", { staticClass: "bootscreensignin-left" }, [
        _c("div", { staticClass: "left-info" }, [
          _c("div", { staticClass: "info-classname van-multi-ellipsis--l2" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.courseInfo.arrange.classNames &&
                    _vm.courseInfo.arrange.classNames.join("，")
                ) +
                " "
            ),
          ]),
          _c("div", { staticClass: "info-tempdiv" }),
          _c("div", { staticClass: "normalinfo van-ellipsis" }, [
            _c("span", { staticClass: "iconfont icon-xxkc" }),
            _vm._v("   "),
            _c("span", { staticClass: "info-text" }, [
              _vm._v(_vm._s(_vm.courseInfo.arrange.name || "")),
            ]),
          ]),
          _c("div", { staticClass: "normalinfo van-ellipsis" }, [
            _c("span", { staticClass: "iconfont icon-jiaoshi" }),
            _vm._v("   "),
            _c("span", { staticClass: "info-text" }, [
              _vm._v(_vm._s(_vm.courseInfo.arrange.speakerText || "")),
            ]),
          ]),
          _c("div", { staticClass: "normalinfo van-ellipsis" }, [
            _c("span", { staticClass: "iconfont icon-address" }),
            _vm._v("   "),
            _c("span", { staticClass: "info-text" }, [
              _vm._v(_vm._s(_vm.courseInfo.arrange.place || "")),
            ]),
          ]),
          _c("div", { staticClass: "normalinfo van-ellipsis" }, [
            _c("span", { staticClass: "iconfont icon-rili" }),
            _vm._v("   "),
            _c("span", { staticClass: "info-text" }, [
              _vm._v(
                _vm._s(
                  _vm.dsf.date.format(
                    _vm.courseInfo.arrange.beginDateTime,
                    "mm月dd日 hh:ii"
                  )
                )
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "left-signin" }, [
          _vm.courseInfo.attendType.indexOf("3") > -1
            ? _c("div", { staticClass: "signin-qrcode" }, [
                _c("img", {
                  staticClass: "signin-qrcode-img",
                  attrs: { src: _vm.qrCodeImgUrl, alt: "" },
                }),
              ])
            : _vm.courseInfo.attendType.indexOf("2") > -1
            ? _c("div", { staticClass: "signin-face" }, [
                _c("div", { staticClass: "signin-face-title" }, [
                  _vm._v("请刷卡"),
                ]),
              ])
            : _c("div", { staticClass: "signin-video" }, [
                _c("div", { staticClass: "signin-video-title" }, [
                  _vm._v("请刷卡"),
                ]),
                _c("img", {
                  staticClass: "signin-video-img",
                  attrs: {
                    src: require("../../../../public/img/product/bootScreen/img-swipe.png"),
                    alt: "",
                  },
                }),
              ]),
          _c("div", { staticClass: "signin-info" }, [
            _c(
              "div",
              { staticClass: "info-headerbg" },
              [
                _vm.attendInfo.errorCode && _vm.attendInfo.errorCode < 30004
                  ? _c("van-image", {
                      staticClass: "info-headerimg",
                      attrs: { src: _vm._f("imgFormat")(_vm.attendInfo.photo) },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "loading",
                            fn: function () {
                              return [
                                _c("van-loading", {
                                  attrs: { type: "spinner", size: "20" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "error",
                            fn: function () {
                              return [
                                _c("img", {
                                  staticClass: "info-headerimg",
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                  },
                                  attrs: {
                                    src: _vm._f("imgFormat")(_vm.defaultHeader),
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        548351208
                      ),
                    })
                  : _c("img", {
                      staticClass: "info-headerimg",
                      attrs: { src: _vm.defaultHeader },
                    }),
              ],
              1
            ),
            _vm.attendInfo.errorCode == 30001
              ? _c("div", { staticClass: "signin-info-content" }, [
                  _c("div", { staticClass: "success" }, [_vm._v("签到成功")]),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.attendInfo.name)),
                  ]),
                ])
              : _vm.attendInfo.errorCode == 30002
              ? _c("div", { staticClass: "signin-info-content" }, [
                  _c("div", { staticClass: "error" }, [_vm._v("重复签到")]),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.attendInfo.name)),
                  ]),
                ])
              : _vm.attendInfo.errorCode == 30003
              ? _c("div", { staticClass: "signin-info-content" }, [
                  _c("div", { staticClass: "error" }, [_vm._v("重复签退")]),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.attendInfo.name)),
                  ]),
                ])
              : _vm.attendInfo.errorCode == 30005
              ? _c("div", { staticClass: "signin-info-content" }, [
                  _c("div", { staticClass: "error" }, [_vm._v("无效卡")]),
                ])
              : _c("div", { staticClass: "signin-info-content" }, [
                  _c("div", { staticClass: "normal-text" }, [
                    _vm._v("请您人脸识别签到或刷卡签到！"),
                  ]),
                ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bootscreensignin-temp" }),
      _c("div", { staticClass: "bootscreensignin-right" }, [
        _c(
          "div",
          {
            staticClass: "right-signinsituationbutton",
            on: { click: _vm.getAllStudentSign },
          },
          [_vm._v("签到情况")]
        ),
        _c("div", { staticClass: "right-signininfo" }, [
          _c("div", { staticClass: "right-signininfo-normalitem" }, [
            _c("div", { staticClass: "normalitem-title" }, [
              _vm._v("实到人数"),
            ]),
            _c("div", { staticClass: "normalitem-text" }, [
              _vm._v(_vm._s(_vm.courseList.realNum || 0)),
            ]),
          ]),
          _c("div", { staticClass: "right-signininfo-normalitem" }, [
            _c("div", { staticClass: "normalitem-title" }, [
              _vm._v("应到人数"),
            ]),
            _c("div", { staticClass: "normalitem-text" }, [
              _vm._v(_vm._s(_vm.courseList.shouldNum || 0)),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "right-signinlist" },
          _vm._l(_vm.courseList.signMessageList, function (item, index) {
            return _c(
              "div",
              {
                key: "signinlist-item" + index,
                staticClass: "signinlist-item",
              },
              [
                _c("van-image", {
                  staticClass: "signinlist-item-header",
                  attrs: { src: _vm._f("imgFormat")(item.photo) },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "loading",
                        fn: function () {
                          return [
                            _c("van-loading", {
                              attrs: { type: "spinner", size: "20" },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "error",
                        fn: function () {
                          return [
                            _c("img", {
                              staticClass: "signinlist-item-header",
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: _vm.defaultImg },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c(
                  "div",
                  {
                    staticClass: "signinlist-item-name van-multi-ellipsis--l2",
                  },
                  [_vm._v(" " + _vm._s(item.name || "") + " ")]
                ),
                _c("div", { staticClass: "signinlist-item-time" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.dsf.date.format(item.signInTime, "hh:ii:ss")) +
                      " "
                  ),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "van-dialog",
        {
          staticClass: "bootscreensignin-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "close-on-click-overlay": true,
            "get-container": "#app",
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c("div", { staticClass: "dialog-maindiv" }, [
            _c("div", { staticClass: "dialog-closebuttondiv" }, [
              _c("div", { staticClass: "dialog-closenotice" }, [
                _vm._v("点击任意阴影处关闭"),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-closebutton",
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-icon_wrong" })]
              ),
            ]),
            _c(
              "div",
              { staticClass: "dialog-maininfo" },
              [
                _c("teacher-sign-in-info", {
                  attrs: {
                    stuList: _vm.stuList,
                    classNameSet:
                      _vm.courseInfo.arrange &&
                      _vm.courseInfo.arrange.classNames
                        ? _vm.courseInfo.arrange.classNames
                        : [],
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "van-dialog",
        {
          staticClass: "bootscreensignin-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "close-on-click-overlay": true,
            "get-container": "#app",
          },
          model: {
            value: _vm.showMistakeAddressDialog,
            callback: function ($$v) {
              _vm.showMistakeAddressDialog = $$v
            },
            expression: "showMistakeAddressDialog",
          },
        },
        [
          _c("div", { staticClass: "dialog-maindiv" }, [
            _c("div", { staticClass: "dialog-closebuttondiv" }, [
              _c("div", { staticClass: "dialog-closenotice" }, [
                _vm._v("点击任意阴影处关闭"),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-closebutton",
                  on: {
                    click: function ($event) {
                      _vm.showMistakeAddressDialog = false
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-icon_wrong" })]
              ),
            ]),
            _c(
              "div",
              { staticClass: "dialog-maininfo" },
              [
                _c("mistake-sign-in-address", {
                  attrs: {
                    attendInfo: _vm.attendInfo,
                    addressInfo: _vm.addressInfo,
                    currentPlace:
                      _vm.courseInfo.arrange && _vm.courseInfo.arrange.place
                        ? _vm.courseInfo.arrange.place
                        : "",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }